import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import ProfessionalCardTopPart from "../ProfessionalCardTopPart/ProfessionalCardTopPart";
import ProfessionalCardBottomPart from "../ProfessionalCardBottomPart/ProfessionalCardBottomPart";

import styles from "./ProfessionalCard.module.css";

export default function ProfessionalCard(props) {
  return (
    <Card>
      <ProfessionalCardTopPart {...props} />
      <ProfessionalCardBottomPart specialization={props.specialization} />
      <div className={styles.proSec1}>
        {/* Placeholder for additional content */}
      </div>
      <CardContent>
        <Sheet
          sx={{
            bgcolor: "background.level1",
            borderRadius: "sm",
            p: 1.5,
            my: 1.5,
            display: "flex",
            gap: 2,
            "& > div": { flex: 1 },
          }}
        >
          <div>
            <Typography level="body3" fontWeight="lg">
              My Properties
            </Typography>
            <Typography fontWeight="lg">{props.myProperties || 0}</Typography>
          </div>
          <div>
            <Typography level="body3" fontWeight="lg">
              Property Reels
            </Typography>
            <Typography fontWeight="lg">{props.followers}</Typography>
          </div>
          {/* <div>
            <Typography level="body3" fontWeight="lg">
              My Rating
            </Typography>
            <Typography fontWeight="lg">{props.myRating || 0}</Typography>
          </div> */}
        </Sheet>
        <Box sx={{ display: "flex", gap: 1.5, "& > button": { flex: 1 } }}>
          <Button variant="solid" color="primary">
            Follow
          </Button>
          <Button variant="outlined" color="neutral">
            More
          </Button>
        </Box>
        <Box sx={{ display: "flex", gap: 1.5, marginTop: "1rem" }}>
          <Button
            variant="solid"
            color="primary"
            // onClick={() =>
            //   (window.location.href = `/realtor/${props.id}/reels`)
            // }
          >
            View Instagram Reels
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
